import { render, staticRenderFns } from "./MenuItemOptionItemsViewer.vue?vue&type=template&id=9aafc358&scoped=true&"
import script from "./MenuItemOptionItemsViewer.vue?vue&type=script&lang=js&"
export * from "./MenuItemOptionItemsViewer.vue?vue&type=script&lang=js&"
import style0 from "./MenuItemOptionItemsViewer.vue?vue&type=style&index=0&id=9aafc358&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9aafc358",
  null
  
)

export default component.exports